import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { ReactComponent as DeleteIcon } from '../../../assets/icons/delete-icon.svg';
import { ReactComponent as EditPencilCard } from '../../../assets/icons/edit-pencil.svg';
import { ReactComponent as Plus } from '../../../assets/icons/plus.svg';
import { ReactComponent as Facility } from '../../../assets/icons/sidebar/facility.svg';
// import { ReactComponent as DotCircle } from '../../../assets/icons/tables/dot-circle.svg';
import { ReactComponent as ExpandIcon } from '../../../assets/icons/tables/expand-icon.svg';
import { ReactComponent as NewTabIcon } from '../../../assets/icons/tables/new-tab.svg';
import { appCurrentBranding } from '../../../config/branding';
import DefaultApiLimit from '../../../config/defaultLimit';
import { branding } from '../../../config/enum';
import {
  AccountsInterFace,
  RequestAccountInterface,
} from '../../../interface/account-management.interface';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import {
  disableAccountManagementFilterApplied,
  fetchAccountManagementFilters,
  fetchAllAccounts,
  setSortData,
  updateAccountManagementFilters,
  refreshAccounts,
} from '../../../redux/slices/AccountManagementSlice';
import { setNotificationMessage } from '../../../redux/slices/NotificationManagementSlice';
import { setPageTitle } from '../../../redux/slices/PageTitleSlice';
import MyButton from '../../../shared-components/button/Button';
import CustomTable from '../../../shared-components/custom-table/CustomTable';
import DeleteWarning from '../../../shared-components/delete-warning/DeleteWarning';
import ModalBox from '../../../shared-components/modal-box/ModalBox';
import SuccessNotification from '../../../shared-components/success-notification/SuccessNotification';
import FacilityDetailsSidePanel from '../../../shared-components/table-side-panel/FacilityDetailsSidePanel';
import { GetParametersFromCommonFilters } from '../../../shared-functions/CommonFilters';
import ConvertUTCtoDateTime from '../../../shared-functions/ConvertUTCtoDateTime';
import { exportCSV, exportPDF } from '../../../shared-functions/ExportFile';
import { permissionCheck } from '../../../shared-functions/JWTDocodeFunction';
import ToFixedValue from '../../../shared-functions/ToFixedValue';
import accountApi from '../../../utils/api/account';
import accountV2Api from '../../../utils/api/v2/accounts';

import AddFacilityAccount from './add-facility-account';

interface ModalInterface {
  title: string;
  header: boolean;
  content: JSX.Element;
  rightCorner: string;
  notification: boolean;
}

/**
 * Facility account list
 * @returns {any} The result
 */
function FacilityAccountList() {
  const { t } = useTranslation('account');
  const dispatch = useAppDispatch();
  const {
    accounts,
    limit,
    page,
    totalPages,
    totalResults,
    loading,
    filterListLoading,
    filters,
    isFilterUpdated,
    sortBy,
    sortField,
  } = useAppSelector((state) => state.accounts);
  const navigate = useNavigate();
  const [openStatus, setOpenStatus] = useState<boolean>(false);
  const [openConfirm, setOpenConfirm] = useState<boolean>(false);
  const [exportLoader, setExportLoader] = useState<boolean>(false);
  const [sidePanelOpen, setSidePanelOpen] = useState<boolean>(false);
  const [account, setAccount] = useState<AccountsInterFace>({
    _id: '',
    id: '',
    name: '',
    email: '',
    date: '',
    phone: '',
    accountCustomId: '',
    isAccountVerified: false,
    documents: [],
    currency: '',
  });
  const [searchParameters, setSearchParameters] = useSearchParams();

  const [isEditMode, setIsEditMode] = useState<boolean>(false);
  const [hiddenColumns, setHiddenColumns] = useState<string[]>([]);
  const [modalView, setModalView] = useState<ModalInterface>({
    title: '',
    header: false,
    content: <div />,
    rightCorner: '',
    notification: false,
  });

  /**
   * Fetch the account details in redus
   * @param {any} data - The data
   */
  const fetchData = (data: RequestAccountInterface) => {
    if (!loading) {
      dispatch(fetchAllAccounts(data));
    }
  };

  /**
   * Modal box close function
   * @param {any} message - The message
   */
  const closeModal = (message: string) => {
    if (message) {
      setOpenStatus(true);
      setModalView({
        title: '',
        header: false,
        content: (
          <SuccessNotification
            title={message}
            description=""
            notificationCloseTimer={3000}
            onNotificationClose={() => {
              setOpenStatus(false);
            }}
          />
        ),
        rightCorner: '',
        notification: true,
      });
    } else {
      setOpenConfirm(false);
      setOpenStatus(false);
    }
  };

  /**
   * Add account function
   */
  const addAccount = () => {
    // searchParameters.delete('facilityId');
    // setSearchParameters(searchParameters);
    setSidePanelOpen(true);
  };

  /**
   * Table pagination function
   * @param {any} value - The value
   */
  const pageAndLimitChange = (value: RequestAccountInterface) => {
    const queryParameters = GetParametersFromCommonFilters(filters);
    fetchData({ ...queryParameters, ...value, sortField, sortBy });
  };

  /**
   * Auto refresh the data
   */
  const handleAutoRefresh = () => {
    const queryParameters = GetParametersFromCommonFilters(filters);

    dispatch(
      refreshAccounts({
        ...queryParameters,
        page,
        limit,
        sortBy,
        sortField,
      }),
    );
  };

  /**
   * View Facility function
   */
  // const viewFacilityFunction = (currentData: any) => {
  //   const accountDetails = accounts.find((value: AccountsInterFace) => value.id === currentData);
  //   if (accountDetails && Object.keys(accountDetails).length > 0) {
  //     const request: AccessFacilityPortal = {
  //       tenantId: accountDetails.tenantId,
  //     };

  //     authApi
  //       .accessFacilityPortal(request)
  //       .then((response) => {
  //         const responseData = response?.data;

  //         window.open(
  //           `${window.origin.replace('admin', 'facility')}/login/credentials?accessToken=${responseData.access.token}&accessTokenExpires=${responseData.access.expires}&refreshToken=${responseData.refresh.token}&refreshTokenExpires=${responseData.refresh.expires}&isEmailVerified=${responseData.isEmailVerified}&isPhoneNumberVerified=${responseData.isPhoneNumberVerified}&isInitialPasswordReset=${responseData.isInitialPasswordReset}&accountVerificationStatus=${responseData.accountVerificationStatus}`,
  //           '_blank',
  //         );
  //       })
  //       .catch((error) => {
  //         dispatch(
  //           setNotificationMessage({
  //             message: error?.response?.data?.message,
  //             status: true,
  //             type: 'error',
  //             code: error?.response?.data?.code,
  //           }),
  //         );
  //       });
  //   }
  // };

  /**
   * Function to refresh data
   */
  const handleRefresh = () => {
    const queryParameters = GetParametersFromCommonFilters(filters);
    fetchData({ ...queryParameters, page, limit, sortField, sortBy });
  };

  /**
   * Reset the account state used for delete confirmation
   */
  const resetAccountState = () => {
    setAccount({
      _id: '',
      id: '',
      name: '',
      email: '',
      date: '',
      phone: '',
      accountCustomId: '',
      isAccountVerified: false,
      documents: [],
      currency: '',
    });
  };

  /**
   * Delete confirm function
   */
  const deleteConfirmFunction = () => {
    accountApi
      .deleteAccount(account?.accountCustomId)
      .then(() => {
        setOpenConfirm(false);
        closeModal(`${t('accountDeletedSuccessfully')}...`);
        handleRefresh();
        resetAccountState();
      })
      .catch((error: any) => {
        dispatch(
          setNotificationMessage({
            message: error?.response?.data?.message,
            status: true,
            type: 'error',
            code: error?.response?.data?.code,
          }),
        );
      });
  };

  /**
   * Function to expand the facility
   * @param {any} facilityId - The facility ID
   */
  const expandFunction = (facilityId: any) => {
    const accountDetails = accounts.find(
      (value: AccountsInterFace) => value.accountCustomId === facilityId,
    );

    if (accountDetails?.accountCustomId) {
      navigate(
        `/ev-admin/accounts/partners/details/payout-management/${accountDetails.accountCustomId}`,
      );
    }
  };

  /**
   * Function to open the facility details in a new tab
   * @param {any} facilityId - The facility ID
   */
  const openInNewTabFunction = (facilityId: any) => {
    const accountDetails = accounts.find(
      (value: AccountsInterFace) => value.accountCustomId === facilityId,
    );

    if (accountDetails?.accountCustomId) {
      window.open(
        `/ev-admin/accounts/partners/details/payout-management/${accountDetails.accountCustomId}`,
        '_blank',
      );
    }
  };

  /**
   * Set the target account and open the delete confirmation modal
   * @param {AccountsInterFace} currentRow - The current row
   */
  const handleDeleteClick = (currentRow: AccountsInterFace) => {
    setAccount(currentRow);
    setOpenConfirm(true);
  };

  /**
   * Opens the side panel directly in edit mode for the given row
   * @param {AccountsInterFace} currentRow - The current row
   */
  const handleEditFromRow = (currentRow: AccountsInterFace) => {
    const parameters = new URLSearchParams(searchParameters);
    parameters.set('accountCustomId', currentRow.accountCustomId);
    parameters.set('action', 'edit');
    setSearchParameters(parameters);
    setIsEditMode(true);

    dispatch(
      setPageTitle({
        title: t('partners'),
        icon: <Facility />,
        count: undefined,
      }),
    );
  };

  const column = [
    {
      label: `${t('facilityId')}`,
      accessorKey: 'accountCustomId' as keyof AccountsInterFace,
      columnWidth: 170,
      /**
       * No of stations
       * @param {any} currentRow - The currentRow
       */
      customData: (currentRow: AccountsInterFace) => (
        <p className="hyper-link-coloum">{currentRow.accountCustomId || '-'}</p>
      ),
    },

    {
      label: `${t('partnerName')}`,
      accessorKey: 'accountName' as keyof AccountsInterFace,
      sortAllow: true,
    },
    {
      label: `${t('email')}`,
      accessorKey: 'email' as keyof AccountsInterFace,
      sortAllow: false,
    },
    {
      label: `${t('phoneNumber')}`,
      accessorKey: 'phoneNumberCountryCode' as keyof AccountsInterFace,
      sortAllow: false,
    },
    ...(appCurrentBranding === branding.VOLTIE
      ? [
          {
            label: t('stripeId'),
            accessorKey: 'stripePaymentId' as keyof AccountsInterFace,
            sortAllow: false,
          },
        ]
      : []),
    {
      label: `${t('noOfStations')}`,
      accessorKey: 'stationCount' as keyof AccountsInterFace,
      sortAllow: true,
      /**
       * No of stations
       * @param {any} currentRow - The currentRow
       */
      customData: (currentRow: AccountsInterFace) => <p>{currentRow.stationCount || 0}</p>,
    },
    {
      label: `${t('noOfChargers')}`,
      accessorKey: 'totalDeviceCount' as keyof AccountsInterFace,
      sortAllow: true,
      /**
       * No of Chargers
       * @param {any} currentRow - The currentRow
       */
      customData: (currentRow: AccountsInterFace) => <p>{currentRow.totalDeviceCount || 0}</p>,
    },
    {
      label: `${t('onlineChargers')}`,
      accessorKey: 'activeDeviceCount' as keyof AccountsInterFace,
      sortAllow: true,
      /**
       * Online Chargers
       * @param {any} currentRow - The currentRow
       */
      customData: (currentRow: AccountsInterFace) => <p>{currentRow?.activeDeviceCount || 0}</p>,
    },
    {
      label: `${t('kwhConsumedPaid')}`,
      accessorKey: 'powerConsumed' as keyof AccountsInterFace,
      sortAllow: true,
      /**
       * KW Consumed
       * @param {any} currentRow - The currentRow
       */
      customData: (currentRow: AccountsInterFace) => {
        return <p>{ToFixedValue(currentRow?.powerConsumed, 3)} kWh</p>;
      },
    },
    // {
    //   label: `${t('verificationStatus')}`,
    //   accessorKey: 'status' as keyof AccountsInterFace,
    //   sortAllow: false,
    //   /**
    //    * Data custom function
    //    * @param {any} currentRow - The currentRow
    //    */
    //   customData: (currentRow: AccountsInterFace) => {
    //     let output = <div />;

    //     switch (currentRow.status) {
    //       case 'pending':
    //         output = (
    //           <div className="tag-warning-label">
    //             <DotCircle /> <span>{t('unverified')}</span>
    //           </div>
    //         );
    //         break;
    //       case 'approved':
    //         output = (
    //           <div className="tag-success-label">
    //             <DotCircle /> <span>{t('verified')}</span>
    //           </div>
    //         );
    //         break;
    //       case 'rejected':
    //         output = (
    //           <div className="tag-danger-label">
    //             <DotCircle /> <span>{t('rejected')}</span>
    //           </div>
    //         );
    //         break;

    //       default:
    //         break;
    //     }

    //     return output;
    //   },
    // },
    {
      label: `${t('action')}`,
      accessorKey: '_id' as keyof AccountsInterFace,
      columnWidth: 160,
      sortAllow: false,
      hideWhenSidePanelOpen: true,
      sticky: 'right' as const,
      /**
       * Row level actions - expand, open in new tab, edit and delete
       * @param {AccountsInterFace} currentRow - The current row
       */
      customData: (currentRow: AccountsInterFace) =>
        currentRow?.accountCustomId ? (
          <div className="action-buttons-wrap">
            <div
              role="presentation"
              className="action-button"
              onClick={(event) => {
                event.stopPropagation();
                expandFunction(currentRow.accountCustomId);
              }}>
              <ExpandIcon className="icon expand" />
            </div>
            <div
              role="presentation"
              className="action-button"
              onClick={(event) => {
                event.stopPropagation();
                openInNewTabFunction(currentRow.accountCustomId);
              }}>
              <NewTabIcon className="icon new-tab" />
            </div>
            {permissionCheck('cpoPartnerUpdate') && (
              <div
                role="presentation"
                className="action-button"
                onClick={(event) => {
                  event.stopPropagation();
                  handleEditFromRow(currentRow);
                }}>
                <EditPencilCard className="icon edit" />
              </div>
            )}
            {permissionCheck('cpoPartnerDelete') && (
              <div
                role="presentation"
                className="action-button"
                onClick={(event) => {
                  event.stopPropagation();
                  handleDeleteClick(currentRow);
                }}>
                <DeleteIcon className="icon delete" />
              </div>
            )}
          </div>
        ) : null,
    },
  ];

  /**
   * Handle the filter data clear function
   * @param {any} sortData - The sortData
   */
  const handleSortFunction = (sortData: any) => {
    const queryParameters = GetParametersFromCommonFilters(filters);
    dispatch(setSortData(sortData));
    fetchData({
      ...queryParameters,
      sortBy: sortData.sortBy,
      sortField: sortData.sortField,
      page: DefaultApiLimit.page,
      limit,
    });
  };

  /**
   * Column definitions for the table
   */
  const currentColumns = [
    { label: t('sNo'), accessorKey: '__serial__' },
    { label: t('facilityId'), accessorKey: 'accountCustomId' },
    { label: t('facilityOwnerName'), accessorKey: 'accountName' },
    { label: t('email'), accessorKey: 'email' },
    { label: t('phoneNumber'), accessorKey: 'phoneNumberCountryCode' },
    { label: t('noOfStations'), accessorKey: 'stationCount' },
    { label: t('noOfChargers'), accessorKey: 'totalDeviceCount' },
    { label: t('onlineChargers'), accessorKey: 'activeDeviceCount' },
    { label: t('kwhConsumedPaid'), accessorKey: 'powerConsumed' },
    { label: t('verificationStatus'), accessorKey: 'status' },
    { label: t('created', 'Created'), accessorKey: 'createdAt' },
    { label: t('lastUpdated', 'Last Updated'), accessorKey: 'updatedAt' },
  ];

  /**
   * Filtering columns for export without hidden columns
   */
  const exportCurrentColumns = currentColumns.filter(
    (col) => col.accessorKey === '__serial__' || !hiddenColumns.includes(col.accessorKey),
  );

  /**
   * Export data function (without field filtering)
   * @param {any} type - The type
   */
  const exportDataPdfOrCSV = (type: string) => {
    const queryParameters = GetParametersFromCommonFilters(filters);
    const payload = {
      ...queryParameters,
    };
    if (sortBy) payload.sortBy = sortBy;
    if (sortField) payload.sortField = sortField;
    setExportLoader(true);
    accountV2Api
      .exportData(payload)
      .then((response) => {
        const headers = exportCurrentColumns.map((col) => col.label);
        const rows = response.data.map((row: AccountsInterFace, index: number) =>
          exportCurrentColumns.map((col) => {
            switch (col.accessorKey) {
              case '__serial__':
                return index + 1;
              case 'activeDeviceCount':
                return row.activeDeviceCount || '0';
              case 'powerConsumed':
                return `${ToFixedValue(Number(row?.powerConsumed), 3)} kWh`;
              case 'status':
                switch (row.submission?.status) {
                  case 'pending':
                    return t('unverified');
                  case 'approved':
                    return t('verified');
                  case 'rejected':
                    return t('rejected');
                  default:
                    return t('notAvailable');
                }

              case 'stationCount':
                return row.stationCount || '0';
              case 'totalDeviceCount':
                return row.totalDeviceCount || '0';
              case 'createdAt':
                return row.createdAt ? ConvertUTCtoDateTime(row.createdAt) : '-';
              case 'updatedAt':
                return row.updatedAt ? ConvertUTCtoDateTime(row.updatedAt) : '-';
              default:
                return (row as any)[col?.accessorKey] || 'N/A';
            }
          }),
        );
        setExportLoader(false);
        if (rows.length > 0) {
          if (type === 'csv') {
            exportCSV(headers, rows, `${t('accountList')}.csv`);
          } else {
            exportPDF(headers, rows, `${t('accountList')}.pdf`);
          }
        }
      })
      .catch((error) => {
        setExportLoader(false);
        dispatch(
          setNotificationMessage({
            message: error?.response?.data?.message,
            status: true,
            type: 'error',
            code: error?.response?.data?.code,
          }),
        );
      });
  };

  /**
   * Function to open side panel on row click
   * @param {any} accountCustomId - The accountCustomId
   */
  const handleOpenSidePanelOnRowClick = (accountCustomId: string) => {
    // Set or update the logId param
    searchParameters.set('accountCustomId', accountCustomId);
    // Apply the updated search params to the URL
    setSearchParameters(searchParameters);

    dispatch(
      setPageTitle({
        title: t('partners'),
        icon: <Facility />,
        count: undefined,
      }),
    );
  };
  /**
   * Close the facility details side panel and reset related state/URL params
   */
  const closeFacilitySidePanel = () => {
    setSidePanelOpen(false);
    setIsEditMode(false);

    setSearchParameters(
      (previous) => {
        const parameters = new URLSearchParams(previous);
        parameters.delete('action');
        parameters.delete('accountCustomId');
        return parameters;
      },
      { replace: true },
    );

    dispatch(
      setPageTitle({
        title: t('partners'),
        icon: <Facility />,
        count: totalResults, // ✅ restore count
      }),
    );
  };

  /**
   * Handle changes to edit mode by updating state and URL parameter
   * @param {any} isEdit - The isEdit
   */
  const handleEditModeChange = (isEdit: boolean) => {
    setIsEditMode(isEdit);
    const newParameters = new URLSearchParams(searchParameters);
    if (isEdit) {
      newParameters.set('action', 'edit');
    } else {
      newParameters.delete('action');
    }
    setSearchParameters(newParameters);
  };

  /**
   * Returns side panel header content: title, expand icon, and edit action.
   */
  const renderSidePanelTopLeftContent = () => {
    if (sidePanelOpen) {
      return (
        <div className="side-panel-header-left-title-actions">
          <p className="side-panel-header-title">{t('addFacility')}</p>
        </div>
      );
    }
    const accountCustomId = searchParameters.get('accountCustomId');
    if (!accountCustomId) return null;

    return (
      <div className="side-panel-header-left-title-actions">
        <p className="side-panel-header-title">
          {isEditMode ? t('editFacility') : t('facilityDetails')}
        </p>
        <div className="side-panel-header-left-icons">
          {!isEditMode && (
            <>
              {/* Expand Icon */}
              <div className="button-wrap">
                <span
                  role="presentation"
                  className="access-facility"
                  onClick={() => expandFunction(accountCustomId)}>
                  <ExpandIcon />
                </span>
                <div className="hover-label">{t('expandPages', 'Expand Pages')}</div>
              </div>

              {/* Edit Icon */}
              {permissionCheck('cpoPartnerUpdate') && (
                <div className="button-wrap">
                  <span
                    role="presentation"
                    className="access-facility"
                    onClick={() => handleEditModeChange(true)}>
                    <EditPencilCard className="icon" />
                  </span>
                  <div className="hover-label">{t('edit', 'Edit')}</div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    );
  };
  useEffect(() => {
    if (isFilterUpdated || accounts.length === 0) {
      const queryParameters = GetParametersFromCommonFilters(filters);
      fetchData({
        page: DefaultApiLimit.page,
        limit,
        start: '',
        ...queryParameters,
      });
      dispatch(disableAccountManagementFilterApplied());
    }
  }, [filters]);

  useEffect(() => {
    if (!sidePanelOpen) {
      dispatch(
        setPageTitle({
          title: t('partners'),
          icon: <Facility />,
          count: totalResults,
        }),
      );
    }
  }, [totalResults, sidePanelOpen, t, dispatch]);

  useEffect(() => {
    if (searchParameters.get('accountCustomId')) {
      const parameters = new URLSearchParams(searchParameters);
      parameters.delete('accountCustomId');
      setSearchParameters(parameters, { replace: true });
    }
  }, []);

  useEffect(() => {
    if (!searchParameters.get('accountCustomId')) {
      setIsEditMode(false);
      if (searchParameters.get('action')) {
        const parameters = new URLSearchParams(searchParameters);
        parameters.delete('action');
        setSearchParameters(parameters, { replace: true });
      }
    }
  }, [searchParameters]);

  return (
    <div>
      <ModalBox
        open={openStatus}
        title={modalView.title}
        content={modalView.content}
        closeModal={() => setOpenStatus(false)}
        header={modalView.header}
        rightCorner={modalView.rightCorner}
        notification={modalView.notification}
      />
      <ModalBox
        title={t('deleteFacilityConfirmTitle')}
        header={false}
        open={openConfirm}
        closeModal={() => {
          setOpenConfirm(false);
          setOpenStatus(false);
          resetAccountState();
        }}
        content={
          <DeleteWarning
            title={t('deleteFacilityConfirmTitle')}
            description={t('deleteFacilityConfirmSubtitle')}
            cancelButtonOnClick={() => {
              setOpenConfirm(false);
              setOpenStatus(false);
              resetAccountState();
            }}
            submitSvgIcon={<DeleteIcon />}
            submitButtonOnClick={deleteConfirmFunction}
          />
        }
      />
      <CustomTable
        version="v2"
        header={column}
        data={accounts}
        limit={limit}
        page={page}
        totalPages={totalPages}
        totalResults={totalResults}
        loading={loading}
        serialNo
        created
        lastUpdated
        sortData={{ sortBy, sortField }}
        handleSortChange={handleSortFunction}
        pageLimitChange={pageAndLimitChange}
        onHiddenColumnsChange={setHiddenColumns}
        actionButton
        height={350}
        filters={filters}
        filtersToDispatch={updateAccountManagementFilters}
        filterListLoading={filterListLoading}
        filterListToDispatch={fetchAccountManagementFilters}
        sizeChangeButtonRequired
        actionDropdown
        exportData={accounts}
        exportLoader={exportLoader}
        exportDataPdfOrCSV={permissionCheck('cpoPartnerExport') ? exportDataPdfOrCSV : undefined}
        isExportRequired={permissionCheck('cpoPartnerExport')}
        rowClickEvent={handleOpenSidePanelOnRowClick}
        rowClickParamsKey="accountCustomId"
        sidePanelEnabled={sidePanelOpen}
        sidePanelManualContent={
          <AddFacilityAccount
            closeModal={closeModal}
            sidebarClosed={() => setSidePanelOpen(false)}
            hideHeader
          />
        }
        onSidePanelClose={closeFacilitySidePanel}
        sidePanelTopLeftContent={renderSidePanelTopLeftContent() ?? undefined}
        rowClickSidePanel={
          <FacilityDetailsSidePanel
            actionActive
            isEditMode={isEditMode}
            onEditModeChange={handleEditModeChange}
            onBack={closeFacilitySidePanel}
            fetchIdFrom="queryParams"
            onSuccess={() => {
              handleEditModeChange(false);
              handleRefresh();
            }}
          />
        }
        rightTopContent={
          <div className="table-bottom-button-list">
            <div className="table-button-item">
              <MyButton
                label={t('addAccount')}
                buttonType="submit"
                onClickFunc={addAccount}
                svgIcon={<Plus />}
                disableButton={!permissionCheck('cpoPartnerAdd')}
              />
            </div>
          </div>
        }
        requiredRefreshToggle
        refreshFunction={handleAutoRefresh}
        refreshRequired
        handleRefresh={handleRefresh}
        hoverLabel={t('refresh')}
        refershCurrentPages={handleRefresh}
      />
    </div>
  );
}

export default FacilityAccountList;
